/** Default map center (Shinjuku, Tokyo) */
export const DEFAULT_CENTER = { lat: 35.6896, lng: 139.6998 } as const

/** Default search radius in meters */
export const DEFAULT_RADIUS = 3000

/** Minimum search radius (prevents micro-queries on extreme zoom) */
export const MIN_SEARCH_RADIUS = 200

/** Maximum search radius (prevents unbounded queries) */
export const MAX_SEARCH_RADIUS = 10_000

/** Japan geographic bounding box for client-side location check */
export const JAPAN_BOUNDS = {
  latMin: 24.0, latMax: 46.0,
  lngMin: 122.0, lngMax: 154.0,
} as const

/** Fraction of old radius: pan displacement threshold to show "Search this area" */
export const SEARCH_PAN_THRESHOLD = 0.5

/** Fraction of old radius: zoom-in threshold (below this → suggest re-search) */
export const SEARCH_ZOOM_IN_THRESHOLD = 0.4

/** Fraction of old radius: zoom-out threshold (above this → suggest re-search) */
export const SEARCH_ZOOM_OUT_THRESHOLD = 1.5
